// Basiert auf https://gitlab.pooliestudios.com/koeln-marathon/app/app-dev

import subSeconds from 'date-fns/subSeconds';
import differenceInSeconds from 'date-fns/differenceInSeconds';
import {API_ENDPOINTS} from '../models/environment';
import EnvironmentProvider from './environment';

export default class ApiProvider {
    errorOpen: boolean = false;

    errorLastShown: Date = subSeconds(new Date(), 300);

    environmentProvider: EnvironmentProvider;

    constructor() {
        this.environmentProvider = new EnvironmentProvider();
    }

    get dataEndpoint(): string {
        return API_ENDPOINTS[this.environmentProvider.current].DATA;
    }

    get environmentAuthorization(): string | null {
        return API_ENDPOINTS[this.environmentProvider.current].Authorization ?? null;
    }

    getData<ResultInterface>(
        year: number,
        endpoint: string,
        params: Record<string, never> = {},
        options: Record<string, never> = {},
    ): Promise<ResultInterface> {
        const url = `${this.dataEndpoint}/${year}/${endpoint}.json`;
        return this.httpGet<ResultInterface>(url, params, options);
    }

    httpGet<ResultInterface>(
        url: string,
        params: Record<string, string> | null = null,
        options: Record<string, string> = {},
    ): Promise<ResultInterface> {
        const getUrl = params ? `${url}?${new URLSearchParams(params)}` : url;
        const headers = new Headers();

        if (this.environmentAuthorization) {
            headers.append('Authorization', this.environmentAuthorization);
        }

        return new Promise((resolve, reject) => {
            fetch(getUrl, {headers, ...options})
                .then((response) => response.json())
                .then((result: ResultInterface) => resolve(result))
                .catch((error: never) => {
                    this.onError(error);
                    reject();
                });
        });
    }

    onError(error) {
        if (!this.errorOpen && differenceInSeconds(new Date(), this.errorLastShown) >= 300) {
            this.errorLastShown = new Date();

            // eslint-disable-next-line no-console
            console.error('Fehler: ', error);

            this.errorOpen = true;
        }
    }
}
